<template>
  <div
    v-if="error !== true && typeof error === 'string' && error.length >= 1"
    class="am3-input-error text-sm mt-1.5 text-[var(--font-colour-danger)]"
    v-html="error"
  />
</template>

<script setup>
const props = defineProps({
  // v-model value
  error: {
    type: [String, Boolean],
    default: false,
  },
})
</script>
